import { getFlexicoTemplate } from "src/utilities/FlexicoAPIs";
import { ProcessTypeConfig } from "../Types/downloadAppModal";
import { getLogicoProcessById, getProcessById } from "../../Utils/AppActivityUtilsAppsyncPlus";

export const PROCESS_TYPE_CONFIG:ProcessTypeConfig = {
  flexico: {
    getProcessResponse: "getFlexicoTemplateRDS",
    getProcess: getFlexicoTemplate,
    processLabel: "label",
    processName: "template_name",
    processKey: "flex_id",
    removeKeys: ["app_id", "mapping_id", "created_by", "updated_by", "created_time_stamp", "last_updated_time_stamp"],
    tancKey: "FLEXICO"
  },
  frisco: {
    getProcessResponse: "getProcessByIDV2RDS",
    getProcess: getProcessById,
    processLabel: "label",
    processName: "process_name",
    processKey: "process_id",
    removeKeys: ["app_id", "created_by", "updated_by", "created_time_stamp", "last_updated_time_stamp"],
    tancKey: "FRISCO"
  },
  logico: {
    getProcessResponse: "getLogicoProcessByID",
    getProcess: getLogicoProcessById,
    processLabel: "display_label",
    processName: "process_name",
    processKey: "logico_process_id",
    removeKeys: ["app_id", "created_by", "last_updated_by", "created_timestamp", "last_updated_timestamp"],
  }
}

export const RIPPLE_DETAILS_TO_REMOVE = ["created_by", "created_time_stamp", "last_updated_by", "last_updated_time_stamp",
  "mapping_id", "ripple_mapping_id", "ripple_id"
]

export const RIPPLE_PARAMETER_DETAILS_TO_REMOVE = ["field_id"]

export const TANC_INFO = {
  TANC: "TANC",
  PERMISSIONS: "PERMISSIONS",
  CONFIGURATION: "CONFIGURATION",
  FILTER: "FILTER"
}